import {
  customerContactQuery,
  useArchiveCustomerContactMutation,
} from "@common/api/customers"
import { ConfirmDialog } from "@common/components/shared/confirm-dialog"
import { handleError } from "@common/utils"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"

export const Route = createFileRoute(
  "/_layout/customer_/$customerId/contacts/_list/$contactId/delete",
)({
  component: DeleteContactDialog,
})

function DeleteContactDialog(): React.ReactElement {
  const { customerId, contactId } = Route.useParams()
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const archiveMutation = useArchiveCustomerContactMutation()
  const { data: contact } = useSuspenseQuery(
    customerContactQuery({ contact_id: contactId }),
  )
  const name = `${contact.first_name} ${contact.last_name}`

  const close = () =>
    navigate({
      to: "/customer/$customerId/contacts/$contactId",
      params: { customerId, contactId },
      search: true,
    })

  const confirm = () =>
    archiveMutation.mutate(
      { contact_id: contactId },
      {
        onSuccess: () => {
          showToast("Archived", `${name} archived.`, "success")
          navigate({
            to: "/customer/$customerId/contacts",
            params: { customerId },
            search: true,
          })
        },
        onError: (error) => handleError(error, showToast),
      },
    )

  return (
    <ConfirmDialog
      title={`Archive ${name}?`}
      description="This hides the contact from active lists and quote recipient pickers. You can restore it from the Archived tab."
      action="Archive"
      tone="default"
      pendingAction="Archiving…"
      pending={archiveMutation.isPending}
      onConfirm={confirm}
      onCancel={close}
    />
  )
}
